(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hci-product-help"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  const link=event.target.closest('[data-hci-contact]');
  if(!link)return;
  const form=document.getElementById(link.hash.slice(1));
  const trigger=form&&form.querySelector('button[aria-controls]');
  if(trigger&&trigger.getAttribute('aria-expanded')!=='true')trigger.click();
});
  } catch(e) { console.error(e); }
})();

})();
